import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const codeLines = [
  { type: 'comment', text: '// Who is APPCORE LABS?' },
  { type: 'blank', text: '' },
  { type: 'code', text: 'const appcore = {' },
  { type: 'property', key: 'name', value: "'APPCORE LABS LIMITED'" },
  { type: 'property', key: 'founded', value: '2025' },
  { type: 'property', key: 'hq', value: "'London, United Kingdom 🇬🇧'" },
  { type: 'property', key: 'mission', value: "'Build apps people actually love'" },
  { type: 'property', key: 'platform', value: "'iOS — because details matter'" },
  { type: 'property', key: 'stack', value: "['Swift', 'React Native', 'Node.js']" },
  { type: 'property', key: 'distribution', value: "'App Store exclusive'" },
  { type: 'property', key: 'philosophy', value: "'Clean code, bold design, zero bloat'" },
  { type: 'property', key: 'status', value: "'Shipping products, not promises 🚀'" },
  { type: 'property', key: 'contact', value: "'hello@appcorelab.co'" },
  { type: 'code', text: '};' },
];

export default function About() {
  const [visibleLines, setVisibleLines] = useState([]);
  const [currentLine, setCurrentLine] = useState(0);
  const [currentChar, setCurrentChar] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (currentLine >= codeLines.length) {
      setIsTyping(false);
      return;
    }

    const line = codeLines[currentLine];
    let fullText = '';
    
    if (line.type === 'comment') {
      fullText = line.text;
    } else if (line.type === 'blank') {
      fullText = '';
    } else if (line.type === 'code') {
      fullText = line.text;
    } else if (line.type === 'property') {
      fullText = `  ${line.key}: ${line.value},`;
    }

    if (currentChar <= fullText.length) {
      const timeout = setTimeout(() => {
        setVisibleLines(prev => {
          const newLines = [...prev];
          newLines[currentLine] = {
            ...line,
            displayText: fullText.substring(0, currentChar)
          };
          return newLines;
        });
        setCurrentChar(prev => prev + 1);
      }, line.type === 'blank' ? 50 : 25);
      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        setCurrentLine(prev => prev + 1);
        setCurrentChar(0);
      }, 150);
      return () => clearTimeout(timeout);
    }
  }, [currentLine, currentChar]);

  const renderLine = (line, index) => {
    if (!line) return null;
    
    if (line.type === 'comment') {
      return <span className="code-comment">{line.displayText}</span>;
    }
    if (line.type === 'blank') {
      return <span>&nbsp;</span>;
    }
    if (line.type === 'code') {
      if (line.displayText?.includes('const')) {
        return (
          <>
            <span className="code-keyword">const</span>
            <span className="code-variable"> appcore</span>
            <span className="code-operator"> = {'{'}</span>
          </>
        );
      }
      return <span className="code-operator">{line.displayText}</span>;
    }
    if (line.type === 'property') {
      const text = line.displayText || '';
      const colonIndex = text.indexOf(':');
      if (colonIndex === -1) {
        return <span className="code-key">{text}</span>;
      }
      const key = text.substring(0, colonIndex);
      const rest = text.substring(colonIndex);
      return (
        <>
          <span className="code-key">{key}</span>
          <span className="code-operator">:</span>
          <span className="code-value">{rest.substring(1)}</span>
        </>
      );
    }
    return null;
  };

  return (
    <div className="about-container">
      <div className="about-glow" />
      <div className="about-glow-secondary" />
      
      <div className="terminal-wrapper">
        <div className="terminal-header">
          <div className="terminal-dots">
            <span className="dot red" />
            <span className="dot yellow" />
            <span className="dot green" />
          </div>
          <span className="terminal-title">appcore.config.js</span>
        </div>
        
        <div className="terminal-body">
          {visibleLines.map((line, index) => (
            <div key={index} className="code-line">
              <span className="line-number">{index + 1}</span>
              <span className="line-content">
                {renderLine(line, index)}
                {index === currentLine && isTyping && <span className="cursor">|</span>}
              </span>
            </div>
          ))}
          {isTyping && visibleLines.length === 0 && (
            <div className="code-line">
              <span className="line-number">1</span>
              <span className="line-content">
                <span className="cursor">|</span>
              </span>
            </div>
          )}
        </div>
      </div>

      <Link to="/" className="back-btn">
        <span className="back-arrow">←</span>
        Back to Home
      </Link>
    </div>
  );
}